// extracted by mini-css-extract-plugin
export default {"article":"Kw9uj5Zzyv6HqDe4spoF"};